export enum ThemePreference {
  Light = 'LIGHT',
  Dark = 'DARK',
  Auto = 'AUTO',
}

export interface UserPreferences {
  theme?: ThemePreference;
}
